<template>
    <div v-if="isShow">
      <div :class="'ticket-wrap ' + wavveVoucherClass(passGroupType)">
        <div class="ticket-inner-wrap">
          <h2 class="m-ticket-title">{{ passGroupName }}</h2>
          <popup-voucher-groups v-for="(data, index) in productGroupList" :key="'groups' + index"
                              :group-info="data"
                              :product-type="passGroupType"
                              :package-detail-list="packageDetailList"
                              :purchase-fn="purchaseFn"
                              :category-index="categoryIndex"
          />
          <p class="notice-message" v-if="passGroupType !== 'one' && passGroupType !== 'package'">매월 자동결제 / 부가세포함</p>
        </div>
      </div>
    </div>
</template>

<script>
import utils from '@/common/util/utils'
import PopupVoucherGroups from '@/components/voucher/PopupVoucherGroups'
import { get } from 'lodash'

export default {
  components: {
    PopupVoucherGroups
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    packageDetailList: {
      type: Array
    },
    purchaseFn: {
      type: Function
    },
    categoryIndex: {
      type: Number
    }
  },
  data () {
    return {
      device: utils.cookies.getDevice()
    }
  },
  computed: {
    productGroupList () {
      return get(this.category, 'productgroups', [])
    },
    isShow () {
      return this.productGroupList.length > 0
    },
    passGroupType () {
      return get(this.category, 'passgroup_type', '')
    },
    passGroupName () {
      return get(this.category, 'passgroup_name', '')
    }
  },
  methods: {
    wavveVoucherClass (productType) {
      return productType === 'voucher' ? 'wavve-voucher' : ''
    }
  }
}
</script>
